import { render, staticRenderFns } from "./help_menu.vue?vue&type=template&id=4e494326&scoped=true"
import script from "./help_menu.vue?vue&type=script&lang=js"
export * from "./help_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e494326",
  null
  
)

export default component.exports